import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'izivia-fab-button-with-loader',
    templateUrl: './iziviaFabButtonWithLoader.component.html',
    styleUrls: ['./iziviaFabButtonWithLoader.component.scss']
})
export class IziviaFabButtonWithLoaderComponent implements OnInit {
    @Input() type: 'submit' | 'reset' | 'button' = 'button';
    @Input() disabled: boolean = false;
    @Input() selected: boolean = false;
    /**
     * This attributes determines the background and border color of the button. By default, buttons have a solid background
     * and the same border color. When outline, background is transparent and only border have color.
     */
    @Input() fill: 'solid' | 'outline' = 'solid';
    @Input() color: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' = 'primary';
    @Input() size: 'small' | 'medium' | 'large' = 'medium';

    @Input() icon?: string;
    @Input() ionIcon?: string;
    @Input() waiting?: boolean;

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output('izivia-click') clickEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

    customClassName: string = '';

    ngOnInit(): void {
        this.customClassName = this.computeComponentClassName();
    }

    @HostListener('click', ['$event'])
    onClick($event: MouseEvent) {
        if (!(this.disabled || this.waiting)) {
            this.clickEvent.emit($event);
        }
    }

    private computeComponentClassName(): string {
        let className: string;

        if (this.color) {
            className = 'fab-button-';

            if (this.fill === 'outline') {
                className += `${this.fill}-`;
            }

            className += `${this.color}`;
        }

        return className || '';
    }
}
